import React from 'react';
import styled from 'styled-components';

export default styled(({ isChosen, ...rest }) => <span {...rest} />)`
  font-weight: ${props => (props.isChosen ? 'bold' : 'normal')};
`;
